jQuery(function ($) {
    function applyActiveStateHandlers($container) {
        $container.find('input, select').each(function () {
            $(this).on('focus', function () {
                $(this).closest('.gfield').addClass('active');
            });

            $(this).on('blur', function () {
                if ($(this).val().length === 0) {
                    $(this).closest('.gfield').removeClass('active');
                }
            });

            if ($(this).val() !== '') {
                $(this).closest('.gfield').addClass('active');
            }
        });
    }

    // Suppress animations briefly
    if (!document.getElementById('gf-no-anim-style')) {
        let style = document.createElement('style');
        style.id = 'gf-no-anim-style';
        style.textContent = '.gf-no-anim * { transition: none !important; animation: none !important; }';
        document.head.appendChild(style);
    }

    // Initial load
    applyActiveStateHandlers($(document));

    // After AJAX render disable transitions, reapply actives, then re-enable next frame
    $(document).on('gform_post_render', function (e, formId) {
        let $form = $('#gform_' + formId);
        $form.addClass('gf-no-anim');
        applyActiveStateHandlers($form);

        // Let the browser paint once with actives applied, then restore transitions
        requestAnimationFrame(function () {
            $form.removeClass('gf-no-anim');
        });
    });
});
